export const roleData =
{
    superadmin: 'superadmin',
    admin: 'admin',
    agent: 'agent',
    blog: 'writer',
}
